import { useMutation } from '@apollo/client'
import { FinishTestSessionPayment, FinishTestSessionPaymentVariables } from '../../types'
import { FINISH_TEST_SESSION_PAYMENT } from './operations'

export const useFinishTestSessionPayment = () =>
  useMutation<FinishTestSessionPayment, FinishTestSessionPaymentVariables>(
    FINISH_TEST_SESSION_PAYMENT
  )
